<template>
  <TheUncle :color="true" title="완료된 사입" description="처리가 완료된 사입 목록입니다.">
    <a-card title="소매 이름">
      <a-breadcrumb slot="extra">
        <a-breadcrumb-item style="color: black">합계</a-breadcrumb-item>
        <a-breadcrumb-item style="color: blue">처리</a-breadcrumb-item>
        <a-breadcrumb-item style="color: green">성공</a-breadcrumb-item>
        <a-breadcrumb-item style="color: red">실패</a-breadcrumb-item>
        <a-breadcrumb-item style="color: #a39a00">대기</a-breadcrumb-item>
      </a-breadcrumb>
    </a-card>
    <a-card
      :title="user.account.username"
      @click="$router.push(`/uncle/completed/${user.account.idx}`)"
      v-for="user in users"
      :key="user.account.idx"
      style="background-color: #e9ecef"
    >
      <a-breadcrumb slot="extra">
        <a-breadcrumb-item style="color: black">{{ user.total }} 개</a-breadcrumb-item>
        <a-breadcrumb-item style="color: blue">{{ user.pending }} 개</a-breadcrumb-item>
        <a-breadcrumb-item style="color: green">{{ user.success }} 개</a-breadcrumb-item>
        <a-breadcrumb-item style="color: red">{{ user.failed }} 개</a-breadcrumb-item>
        <a-breadcrumb-item style="color: #a39a00">{{ user.waiting }} 개</a-breadcrumb-item>
      </a-breadcrumb>
    </a-card>
    <a-button
      style="margin-top: 0.5em;"
      @click="$router.push('/uncle/completed/all')"
      type="primary"
      icon="team"
    >전체보기</a-button>
  </TheUncle>
</template>
<script>
import TheUncle from "../../../components/Uncle/TheUncle";
import Axios from "axios";
import config from "../../../config";
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import OPCODE from "../../../libs/OPCODE";

export default {
  name: "UncleSaibCompleted",
  components: { TheUncle },
  data() {
    this.onRefresh();
    return {
      users: []
    };
  },
  methods: {
    async onRefresh() {
      const { data } = await Axios.get(
        `${config.hostname}/v1/uncle/saib/completed`,
        {
          withCredentials: true
        }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.users = data.completed;
            break;
          default:
            config.alert.mixin({
              title: "알 수 없는 오류가 발생했습니다.",
              type: "error"
            });
            break;
        }
      }
    }
  }
};
</script>